import ThemeReducer from './ThemeReducer';
import SidebarMenuReducer from './SidebarMenuReducer';
import SettingsReducer from './SettingsReducer';
import SessionReducer from './SessionReducer';
import DevicesReducer from './DevicesReducer';
import PositonsReducer from './PositonsReducer';
import DriversReducer from './DriversReducers';
import GeofencesReducer from './GeofencesReducers';
import GroupsReducer from './GroupsReducers';
import MaintenancesReducer from './MaintenanceReducers';
import AssetsReducer from './AssetsReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  ThemeReducer,
  SidebarMenuReducer,
  SettingsReducer,
  SessionReducer,
  DevicesReducer,
  PositonsReducer,
  DriversReducer,
  GeofencesReducer,
  GroupsReducer,
  MaintenancesReducer,
  AssetsReducer,
});

export default rootReducer;
